import React from 'react';

import Gear from './gear';

const icon = (props) => {
  return <svg width={props.width} viewBox="0 0 512 512">
    <Gear fill={props.fill} />
  </svg>
}

export default icon;
